export const fonts = {
  'Aeroport Medium': [
    {
      weight: 'normal',
      style: 'normal',
    },
  ],
  'Aeroport Light': [
    {
      weight: 'normal',
      style: 'normal',
    },
  ],
  'Aeroport Mono': [
    {
      weight: 'normal',
      style: 'normal',
    },
  ],
  'Druk Text Cy Medium': [
    {
      weight: 'normal',
      style: 'normal',
    },
  ],
}
